module.exports = __webpack_public_path__ + "assets/3CirclesCDetailed.d607bafb5e7f5eaf4de4f234e5fccdb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/3CirclesCDetailed.png
// module id = 444
// module chunks = 0